<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal">
          <div class="modal-head">
            <h1><img src="@/assets/static/images/ribon.png" alt="리본" style="width: 4rem; margin: 0 auto;" /></h1>
          </div>
          <div class="modal-con">
            <div class="modal-txt">
              해당 상은 발인 완료되었습니다.
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn primary medium" @click="close">확인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
const emits = defineEmits(['close']);

const close = () => {
  setTimeout(() => {
    emits('close');
  }, 200);
};
</script>

<style scoped></style>
